import { useState } from "react";
import styles from "./index.module.less";
import { Form } from "antd";
const InputBox = ({
  children,
  name,
  rules,
  error,
}: {
  children?: any;
  name?: string;
  rules?: any;
  error?: boolean;
}) => {
  const [isActive, setIsActive] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const handleMouseEnter = (e: React.MouseEvent) => {
    if (error) return;
    setIsActive(true);

    const rect = e.currentTarget.getBoundingClientRect();
    setPosition({ x: e.clientX - rect.left, y: e.clientY - rect.top });
  };
  const handleMouseLeave = () => {
    if (error) return;
    setIsActive(false);
  };
  const handleMouseMove = (e: React.MouseEvent) => {
    if (error) return;
    const rect = e.currentTarget.getBoundingClientRect();
    setPosition({ x: e.clientX - rect.left, y: e.clientY - rect.top });
  };
  return (
    <div
      className={styles.inputBox}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onMouseMove={handleMouseMove}
      style={{
        background: error
          ? "#FA6B6B"
          : `radial-gradient(${isActive ? "200px" : "0"} at ${
              position.x
            }px 34px, rgb(255, 255, 255), transparent 80%)`,
      }}
    >
      {name ? (
        <Form.Item name={name} noStyle rules={rules}>
          {children}
        </Form.Item>
      ) : (
        children
      )}
    </div>
  );
};
export default InputBox;
